import type { CityConfig } from "@/pages/city-template/types";

export const ontarioOrConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Oregon Vital Records (Birth, Death, Marriage)", desc: "Request certified birth, death, and marriage certificates from Oregon Vital Records.", url: "https://www.oregon.gov/oha/PH/BirthDeathCertificates/Pages/index.aspx" },
    { icon: "ri-government-line", label: "Malheur County Clerk Vital Records", desc: "Obtain vital records through the Malheur County Clerk's office in Vale.", url: "https://www.co.malheur.or.us/" },
    { icon: "ri-global-line", label: "VitalChek — Order Vital Records Online", desc: "Official online ordering partner of Oregon Vital Records for certified certificates.", url: "https://www.vitalchek.com/" },
  ],
  city: "Ontario",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "ontario-or",
  route: "/cities/ontario-or",
  title: "Emergency Passport Ontario, OR | Expedited Passport Services Malheur County",
  metaDescription: "Emergency passport and expedited passport services in Ontario, Oregon — as fast as 24 hours. Serving Malheur County, Nyssa, Payette ID, and the Treasure Valley border area. A+ BBB rated registered State Dept. courier. Rush passport renewal for Ontario OR travelers.",
  h1: "Emergency & Expedited Passport Services in Ontario, Oregon",
  heroSubtitle: "Passport expired before your international trip? Fast Passport Center helps Ontario, OR and Malheur County travelers get expedited passports in as little as 24 hours. Eastern Oregon's fastest passport courier — start online, no trip to Seattle required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Ontario%20Oregon%20Treasure%20Valley%20with%20Snake%20River%20and%20wide%20open%20high%20desert%20landscape%2C%20golden%20afternoon%20light%20on%20irrigated%20fields%20and%20desert%20terrain%2C%20Owyhee%20Mountains%20visible%20in%20distance%2C%20eastern%20Oregon%20arid%20landscape%20with%20vibrant%20sky%20and%20warm%20earth%20tones%2C%20photorealistic%20landscape%20photography%2C%20no%20text%20or%20signs%20visible&width=1800&height=700&seq=ontario-or-hero-01&orientation=landscape",
  heroImageAlt: "Snake River and Treasure Valley near Ontario Oregon in golden afternoon light",
  geoPosition: "44.0268;-116.9629",
  geoPlacename: "Ontario, Oregon",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "About 530 miles northwest — over 7 hours by car",
  },
  nearbyCitiesZips: [
    { name: "Ontario", zips: "97914" },
    { name: "Nyssa", zips: "97913" },
    { name: "Vale", zips: "97918" },
    { name: "Juntura", zips: "97911" },
    { name: "Adrian", zips: "97901" },
    { name: "Payette (ID)", zips: "83661" },
    { name: "Fruitland (ID)", zips: "83619" },
    { name: "Weiser (ID)", zips: "83672" },
    { name: "Caldwell (ID)", zips: "83605" },
    { name: "Nampa (ID)", zips: "83651" },
    { name: "Boise (ID)", zips: "83701–83720" },
    { name: "Baker City", zips: "97814" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit to our facility. Complete your expedited passport order from Ontario or anywhere in the Treasure Valley border area." },
    { icon: "ri-truck-line", title: "Overnight Shipping from Ontario or Boise", desc: "Ship your documents overnight from FedEx or UPS in Ontario, Nampa, or Boise. Your documents arrive at our processing center the next morning." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is professionally reviewed before submission — especially important for remote Malheur County applicants who are 530 miles from the nearest passport agency." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the nearest regional passport agency — bypassing the public appointment system entirely." },
  ],
  testimonials: [
    {
      name: "Randy B.",
      location: "Ontario, OR",
      rating: 5,
      text: "Realized my passport expired two weeks before a Mexico vacation. Fast Passport Center renewed it in 5 days. I shipped from the FedEx in Ontario — they confirmed everything before I sent it. The whole process was smoother than I expected.",
      service: "Passport Renewal",
    },
    {
      name: "Carol N.",
      location: "Nyssa, OR",
      rating: 5,
      text: "Emergency passport for my husband — unexpected family issue in Canada. Fast Passport Center got it done in 4 days. Being in Nyssa we didn't have many options, but they made it work perfectly. Very professional.",
      service: "Emergency Passport",
    },
    {
      name: "Dave T.",
      location: "Payette, ID",
      rating: 5,
      text: "I'm technically in Idaho but I'm 10 minutes from Ontario, OR. Fast Passport Center helped me get my first passport — they walked me through what I needed at the Ontario post office and handled the processing. Passport in 9 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "ontario-post",
      name: "Ontario Post Office",
      type: "USPS Passport Acceptance",
      address: "64 SW 2nd Ave",
      city: "Ontario",
      state: "OR",
      zip: "97914",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Downtown Ontario — primary Malheur County location",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance facility for Ontario and Malheur County. Appointment required — availability can be limited. Call ahead to confirm current hours and service.",
      icon: "ri-mail-line",
    },
    {
      id: "nyssa-post",
      name: "Nyssa Post Office",
      type: "USPS Passport Acceptance",
      address: "29 N 3rd St",
      city: "Nyssa",
      state: "OR",
      zip: "97913",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–3:30pm",
      distance: "Nyssa — about 8 miles south of Ontario",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Small Nyssa post office. Very limited hours — confirm availability before driving.",
      icon: "ri-mail-line",
    },
    {
      id: "payette-post",
      name: "Payette Post Office (ID)",
      type: "USPS Passport Acceptance",
      address: "110 N 8th St",
      city: "Payette",
      state: "ID",
      zip: "83661",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Payette, ID — about 5 miles across the Snake River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Idaho option for Ontario area residents. U.S. passport applications are the same regardless of state.",
      icon: "ri-mail-line",
    },
    {
      id: "malheur-county-clerk",
      name: "Malheur County Clerk",
      type: "County Passport Acceptance",
      address: "251 B St W",
      city: "Vale",
      state: "OR",
      zip: "97918",
      phone: "541-473-5151",
      hours: "Mon–Fri 8am–5pm (by appointment)",
      distance: "Vale — county seat, about 12 miles east of Ontario",
      website: "https://www.co.malheur.or.us/",
      websiteLabel: "Malheur County Website",
      notes: "Malheur County Clerk passport acceptance in Vale. Appointment required — sometimes has better availability than Ontario USPS.",
      icon: "ri-government-line",
    },
    {
      id: "nampa-post",
      name: "Nampa Post Office (ID)",
      type: "USPS Passport Acceptance",
      address: "520 13th Ave S",
      city: "Nampa",
      state: "ID",
      zip: "83651",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Nampa, ID — about 35 miles east via I-84",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Larger Idaho option for Ontario area residents. Better appointment availability than small Malheur County offices.",
      icon: "ri-mail-line",
    },
    {
      id: "caldwell-post",
      name: "Caldwell Post Office (ID)",
      type: "USPS Passport Acceptance",
      address: "4606 Elmore Rd",
      city: "Caldwell",
      state: "ID",
      zip: "83605",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Caldwell, ID — about 25 miles east via I-84",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Caldwell option for Treasure Valley border area residents seeking more passport appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Ontario, Oregon?",
      a: "Yes. Through Fast Passport Center, Ontario and Malheur County travelers can get an emergency passport in as fast as 24 hours. Ontario, OR does not have a regional passport agency — the closest is Seattle, over 530 miles away. Our registered courier service provides Ontario travelers with priority processing without requiring a cross-state road trip.",
    },
    {
      q: "How do I expedite a passport from Ontario, OR?",
      a: "Expediting a passport from Ontario is straightforward with Fast Passport Center. Start your order online, receive your personalized document checklist, and ship overnight from the FedEx or UPS in Ontario or Nampa, ID. We handle expedited processing through reserved agency channels. Processing can be as fast as 2–9 business days.",
    },
    {
      q: "How far is Ontario, OR from the nearest passport agency?",
      a: "Ontario, OR is approximately 530 miles from the Seattle Passport Agency — over 7 hours by car each way. That's simply not practical for most Malheur County residents. Fast Passport Center is your best option for urgent passport processing in the Ontario, OR area.",
    },
    {
      q: "Can Boise, Idaho residents near Ontario, OR use your service?",
      a: "Absolutely — Fast Passport Center serves applicants regardless of their state. The Treasure Valley straddles the Oregon-Idaho border, and many Ontario-area residents are technically in Idaho. U.S. passport applications are the same process regardless of state, and we serve the entire Snake River / Treasure Valley area.",
    },
    {
      q: "Where can I apply for a passport near Ontario, OR?",
      a: "Passport acceptance facilities near Ontario include the Ontario Post Office, Nyssa Post Office, Malheur County Clerk in Vale, and Idaho options in Payette, Caldwell, and Nampa. However, standard processing takes 6–13 weeks. If you need your passport faster, use Fast Passport Center's expedited courier service.",
    },
    {
      q: "Can I get an expedited passport for a Canada or Mexico trip from Ontario, OR?",
      a: "Yes. Whether you're planning a hunting trip to B.C., a vacation to Mexico, or a business trip to Canada, Fast Passport Center can expedite your passport from the Ontario, OR area. Processing starts in as little as 3 business days after your documents are shipped.",
    },
    {
      q: "How long does standard passport processing take from Ontario, OR?",
      a: "Standard USPS processing from Ontario, OR takes 6–13 weeks. The limited appointment availability at the Ontario post office and small Malheur County facilities can add additional delays. If your trip is within 10 weeks, use Fast Passport Center's expedited service.",
    },
    {
      q: "Can I renew my passport from Ontario, OR without visiting an office?",
      a: "Yes. Most adults renewing a passport (issued at age 16+ within the last 15 years) can do so entirely by mail — no in-person visit required. Start your order online, receive your checklist, and ship overnight from the Ontario FedEx or Nampa UPS location.",
    },
    {
      q: "What airports do Ontario, OR area travelers use for international flights?",
      a: "Boise Airport (BOI) is the primary commercial airport for Ontario and Treasure Valley area travelers — about 60 miles east via I-84. For a broader range of direct international flights, Portland International Airport (PDX) is about 375 miles west. Both require a valid U.S. passport for international departure.",
    },
    {
      q: "Can I get a child passport from Ontario, Oregon?",
      a: "Yes. Child passports for minors under 16 require an in-person acceptance visit with both parents (or documented exceptions). We provide a complete checklist for the Ontario or Payette post office acceptance process and handle expedited processing after your documents are submitted.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Ontario, OR", address: "101 SE 1st Ave, Ontario, OR 97914", hours: "Daily 8 AM – 9 PM" },
    { name: "Walmart — Ontario, OR", address: "466 SE 1st Ave, Ontario, OR 97914", hours: "Daily 7 AM – 11 PM" },
    { name: "Safeway — Ontario, OR", address: "140 E Idaho Ave, Ontario, OR 97914", hours: "Daily 6 AM – 11 PM" },
    { name: "Walgreens — Nampa, ID", address: "4415 E Flamingo Ave, Nampa, ID 83687", hours: "Daily 8 AM – 9 PM" },
    { name: "Walmart — Nampa, ID", address: "3900 E Flamingo Ave, Nampa, ID 83687", hours: "Daily 7 AM – 11 PM" },
    { name: "The UPS Store — Nampa, ID", address: "824 Nampa Blvd, Nampa, ID 83687", hours: "Mon–Fri 8 AM – 6 PM" },
    { name: "FedEx — Caldwell, ID", address: "4606 Elmore Rd, Caldwell, ID 83605", hours: "Mon–Fri 8 AM – 7 PM" },
    { name: "FedEx Office — Boise, ID", address: "475 W Parkcenter Blvd, Boise, ID 83706", hours: "Mon–Fri 7 AM – 9 PM" },
    { name: "Walgreens — Payette, ID", address: "402 N 7th St, Payette, ID 83661", hours: "Daily 8 AM – 9 PM" },
    { name: "CVS — Caldwell, ID", address: "1608 Blaine St, Caldwell, ID 83605", hours: "Daily 7 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Ontario Driver & Motor Vehicle Services",
      address: "250 Orchard Ave, Ontario, OR 97914",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Primary Malheur County DMV office. REAL ID, driver licenses, state IDs. Appointment recommended.",
      featured: true,
    },
    {
      name: "Idaho DMV — Canyon County (Caldwell, ID)",
      address: "1115 Albany St, Caldwell, ID 83605",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Idaho DMV option for Treasure Valley residents on the Idaho side of the border.",
      featured: false,
    },
    {
      name: "Baker City Driver & Motor Vehicle Services",
      address: "2480 Cedar St, Baker City, OR 97814",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Baker County DMV for Ontario area Oregon residents needing REAL ID.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BOI",
      name: "Boise Airport",
      distance: "Primary commercial airport — about 60 miles east via I-84",
      address: "3201 Airport Way, Boise, ID 83705",
      note: "BOI is the most practical commercial airport for Ontario, OR and Treasure Valley travelers. It offers domestic connections to major hubs and some international flights to Canada and Mexico. For broader direct international options, PDX or SEA are better choices.",
      flightUrl: "https://www.iflyboise.com/",
      flightLabel: "BOI Airport Website",
      featured: true,
    },
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "Larger international hub — about 375 miles west via I-84",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "PDX offers the broadest range of direct international flights from the Pacific Northwest — Europe, Asia, Canada, Latin America. Some Ontario area travelers drive to PDX for better flight options. Valid passport required for all international departures.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Emergency passport for Ontario, OR and Malheur County travelers — at 530 miles from Seattle, our registered courier service is the only practical option for urgent processing in the Treasure Valley area.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Lost and stolen passport replacement"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Expedited Passport Renewal",
      description: "Passport expired before a Mexico vacation, Canada trip, or Boise international flight? Ship overnight from Ontario or Nampa — no office visit required for most renewals. Processing as fast as 3 business days.",
      bullets: ["No in-person visit for most renewals", "Ship from Ontario FedEx or Nampa UPS", "3 business days processing available"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost passport before an international trip? We guide Ontario and Treasure Valley travelers through DS-64 reporting and expedited replacement without requiring an impossible drive to Seattle.",
      bullets: ["DS-64 form guidance included", "Urgent replacement available", "Remote Oregon and Idaho border service"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Child passports for Ontario and Malheur County families — minors under 16 require an in-person acceptance step. We provide complete instructions for the Ontario or Payette post office.",
      bullets: ["Both parents typically required", "Complete checklist provided", "Expedited after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport (First-Time)",
      description: "First passport for Ontario, OR residents. We guide you through the in-person acceptance step at the Ontario or Payette post office and handle expedited processing afterward.",
      bullets: ["Step-by-step acceptance checklist", "Clear guidance for first-time applicants", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Registered Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — giving Ontario, OR and Treasure Valley travelers priority processing access that standard USPS and post office services simply cannot match.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not impacted by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Services",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, and second passports for frequent international travelers — all available from Ontario, OR and the Idaho border area.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Ontario, Oregon travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Expedited Passport Renewal", description: "Fast expedited passport renewal for Ontario, OR and Malheur County residents." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier passport service serving Ontario, OR and the Treasure Valley border area." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement for Ontario, OR travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Malheur County and Treasure Valley families." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long to Apply", description: "Ontario, OR is over 500 miles from the nearest passport agency. There is no shortcut here — standard USPS processing takes 6–13 weeks and urgent agency appointments require a full-day drive to Seattle. Apply early." },
    { icon: "ri-camera-off-line", title: "Passport Photo Problems", description: "Shadows, incorrect background, or wrong exposure cause rejection. Walgreens and Walmart in Ontario can take passport photos — we send exact specifications." },
    { icon: "ri-file-damage-line", title: "Incomplete Application Forms", description: "One wrong date, one missing field — your application is returned and you lose weeks. Fast Passport Center reviews every document before submission." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate", description: "Some Malheur County birth certificates don't meet passport requirements. We verify exactly what you need before you make any trips." },
    { icon: "ri-calendar-close-line", title: "Underestimating Ontario's Isolation", description: "Ontario, OR is genuinely remote. The nearest major passport acceptance center is Boise (60 miles). The nearest passport agency is Seattle (530 miles). Fast Passport Center is designed for exactly this situation." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch at BOI or PDX", description: "Your passport name must exactly match your airline booking. Post-marriage name changes, middle name inconsistencies, and hyphens cause gate problems at Boise and Portland airports." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your travel date. Complete your order from Ontario or anywhere in the Treasure Valley area." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send your document checklist immediately — exactly what's needed for your Ontario, OR or Idaho border situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Overnight from Ontario or Nampa", description: "Drop off at FedEx or UPS in Ontario, Nampa, or Caldwell. Most are open evenings for after-work convenience." },
    { number: "04", icon: "ri-building-2-line", title: "Reserved Agency Submission", description: "We submit through our reserved passport agency slots — no impossible drive to Seattle required." },
    { number: "05", icon: "ri-passport-line", title: "Passport Delivered to You", description: "Your completed passport ships directly to your Ontario, OR or Treasure Valley address." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Life-or-death emergencies only",
        "Seattle agency — 530 miles from Ontario, OR",
        "7+ hour drive each way",
        "Strict eligibility requirements",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Expert document review included",
        "Dedicated agent assigned",
        "Daily status updates",
        "No drive to Seattle required",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Faster than USPS self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access",
        "Limited appointment availability in Malheur County",
        "No document review — errors cause rejection",
        "No dedicated agent",
        "Not suitable for travel within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Seattle agency, 530 miles away", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Seattle (7+ hours each way)", fpc: "Ship overnight from Ontario or Nampa" },
    { feature: "Processing Speed", agency: "Emergency travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed tiers" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review before submission" },
    { feature: "Remote Area Support", agency: "No support — you are on your own", fpc: "Dedicated agent for every Malheur County case" },
    { feature: "Government Shutdowns", agency: "Operations may be suspended", fpc: "Not affected" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Emergency passport in La Grande", route: "/cities/la-grande" },
    { name: "Expedited passport in Pendleton", route: "/cities/pendleton" },
    { name: "Rush passport services in Bend", route: "/cities/bend" },
    { name: "Fast passport help in Portland", route: "/cities/portland" },
    { name: "Oregon expedited passport guide", route: "/states/oregon" },
  ],
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeNote: "After starting your order online, we send your personalized document checklist and shipping instructions. Ship overnight from Ontario FedEx or Nampa UPS — no in-person visit to our facility required.",
  fpcOfficeDistance: "Serving Ontario, OR and all of the Treasure Valley / Malheur County area remotely",
  serviceAreaIntro: "Whether you're in Ontario, Nyssa, Vale, or across the Snake River in Payette, Caldwell, or Nampa — Fast Passport Center makes expedited passport services accessible from the Oregon-Idaho border area.",
  nearbyCitiesIntro: "We serve all Malheur County zip codes plus the Idaho Treasure Valley communities. Ship overnight and your documents arrive at our processing center the next morning.",
  howItWorksIntro: "Getting an expedited passport from Ontario, OR is simpler than it seems — even at 530 miles from the nearest passport agency. Start online, ship from your local FedEx or UPS, and we handle everything.",
  mistakesIntro: "These are the most common passport mistakes from Malheur County and Treasure Valley border area travelers. Fast Passport Center reviews your documents before submission to prevent these costly problems.",
  testimonialsIntro: "Real reviews from Ontario, Nyssa, and Treasure Valley travelers who needed their passports fast and trusted Fast Passport Center.",
  faqIntro: "The most common questions from Ontario, OR and Malheur County residents about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  travelTiming: {
    title: "Travel Timing & Passport Urgency for Ontario, Oregon Residents",
    intro: "Ontario, OR sits at the Oregon-Idaho border in the Treasure Valley — a strategic location with unique travel patterns driven by agricultural exports, Canadian hunting, and the Boise metro connection. Understanding these patterns helps us anticipate the passport urgencies that arise here.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "Boise Airport (BOI) — 60 Miles East",
        subtitle: "Primary commercial airport for Ontario and Treasure Valley",
        description: "Boise Airport is the most practical departure point for Ontario, OR and Treasure Valley residents traveling internationally. BOI offers connections to major hubs including Seattle, Denver, Los Angeles, and Phoenix, as well as some direct international services to Cancun and Vancouver. For broader direct international flights to Europe and Asia, travelers typically connect through Seattle or Portland. A valid U.S. passport is required for all international flights — check yours before booking.",
        tip: "Check passport expiration before booking through BOI. Even for domestic connections to international hubs, you'll need your passport at the first international checkpoint. Canada and Mexico departures from BOI require a valid passport.",
      },
      {
        icon: "ri-map-pin-2-line",
        title: "Canada Border — B.C. & Alberta",
        subtitle: "Via Oroville/Osoyoos, WA or northern Idaho crossings",
        description: "Ontario and Treasure Valley residents travel to British Columbia and Alberta for hunting, fishing, skiing, and family visits. The B.C. border is accessible via Washington state crossings (Oroville/Osoyoos) or through northern Idaho. Fall hunting season (August–November) creates the largest spike in urgent passport requests from the Ontario area — hunters often discover expired passports only when booking B.C. hunting licenses online just weeks before their trip.",
        tip: "B.C. hunting and fishing license booking now requires valid passport confirmation at time of purchase for U.S. residents. Check your passport expiration before starting the B.C. license application — not after.",
      },
      {
        icon: "ri-seedling-line",
        title: "Agricultural Export & International Trade",
        subtitle: "Pacific Rim onion, potato, and dairy exports",
        description: "Malheur County is one of Oregon's most productive agricultural regions — onions, potatoes, sugar beets, and dairy. Agricultural businesses in the Ontario area export to Japan, Taiwan, South Korea, and Canada. Export-related travel for trade shows, buyer visits, and inspections creates a consistent demand for expedited passport renewals. These trips often have flexible windows but compressed final booking timelines.",
        tip: "Agricultural trade travel to Japan and South Korea often requires applying for a Japanese transit or business visa. Both require a valid passport. If your passport has less than 12 months remaining, renew before visa applications.",
      },
      {
        icon: "ri-briefcase-line",
        title: "Treasure Valley Business & Tech Sector",
        subtitle: "Boise metro tech corridor, Amazon, Micron",
        description: "The Boise-Ontario Treasure Valley has grown significantly as a tech and manufacturing hub. Ontario-area residents increasingly commute to or work with Boise-metro tech employers (Amazon, Micron, HP). International business travel for this sector can have 1–2 week notice — often confirmed when your employer books flights and you realize your passport expired. Fast Passport Center handles dozens of urgent tech sector renewals from the Treasure Valley area each year.",
        tip: "If you work in tech or manufacturing and your employer occasionally sends you on short-notice international trips, renew your passport when it has 2+ years remaining. The last thing you want is a last-minute renewal scramble from Ontario, 530 miles from Seattle.",
      },
    ],
    callout: {
      icon: "ri-map-2-line",
      title: "530 Miles from Seattle — The Most Remote Passport Situation in Oregon",
      description: "Ontario, OR is the most geographically isolated major community in Oregon relative to a regional passport agency. At 530 miles from Seattle and over 375 miles from Portland, there is no practical self-service option for urgent passport needs. Fast Passport Center was built for exactly this — bringing priority passport processing to the most remote Oregon communities.",
    },
  },
  destinations: {
    title: "Where Ontario, OR Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations and travel patterns we see most from Malheur County and Treasure Valley clients. Each carries a predictable passport urgency that geography and local industry create.",
    stats: [
      { stat: "530 Mi", label: "from Ontario, OR to Seattle Passport Agency — the farthest from a passport agency of any major Oregon city" },
      { stat: "60 Mi", label: "from Ontario to Boise Airport — the primary commercial hub for Treasure Valley international travel" },
      { stat: "Aug–Nov", label: "B.C. hunting and fishing season — the peak period for Malheur County urgent passport requests" },
      { stat: "6 Months", label: "minimum passport validity required by Mexico, Japan, and most European countries" },
    ],
    destinations: [
      {
        name: "Canada (B.C. & Alberta)",
        context: "Hunting, fishing, skiing, and family visits — the primary international destination for Ontario, OR and Treasure Valley residents",
        urgency: "B.C. hunting season (Aug–Nov) triggers the largest spike in Malheur County urgent passport renewals",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Mexico",
        context: "Winter vacations to Puerto Vallarta, Cabo, and Cancun — popular among Ontario and Treasure Valley families escaping harsh Eastern Oregon winters",
        urgency: "Mexico requires 6 months validity; winter bookings often confirmed just weeks before departure",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Japan & South Korea",
        context: "Onion, potato, and dairy export trade shows in Japan and South Korea — the Pacific Rim is the primary export market for Malheur County agriculture",
        urgency: "Trade travel to Japan typically has 2–4 week confirmation; Japan visa requires valid passport",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Europe",
        context: "Agricultural machinery trade shows in Germany, food industry events in France, and European vacation travel by Ontario area retirees",
        urgency: "ETIAS (coming 2025+) will require pre-registration with a valid passport; renew early to avoid delays",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Costa Rica & Central America",
        context: "Eco-tourism, retirement scouting, and agricultural research trips from the Ontario area farming community",
        urgency: "Costa Rica requires 6 months passport validity; winter bookings often confirmed weeks in advance",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Alaska",
        context: "Hunting and fishing from Treasure Valley — some Ontario area residents travel to Bellingham or Seattle for Alaska ferries and cruises",
        urgency: "Alaska cruise bookings from Treasure Valley area typically confirmed 4–8 weeks before departure",
        icon: "ri-map-pin-2-line",
      },
    ],
    crossLinksTitle: "Explore Other Eastern Oregon Service Areas",
    crossLinksDesc: "We serve travelers throughout Eastern Oregon and the Treasure Valley border area with the same expedited passport processing expertise.",
    crossLinks: [
      { name: "La Grande", route: "/cities/la-grande" },
      { name: "Pendleton", route: "/cities/pendleton" },
      { name: "Bend", route: "/cities/bend" },
    ],
  },
};